$(document).ready(function() {

    window.ScriptsActivator.funcLoaded = false;
    window.ScriptsActivator.markLoaded = false;
    window.ScriptsActivator.statLoaded = false;

    window.ScriptsActivator.loadScripts = function (scripts) {
        if (Object.keys(scripts).length === 0)
            return;

        for (var key in scripts) {
            var s = scripts[key];
            if (typeof s === "function") {
                s.call();
            } else {
                for (var skey in s) {
                    var ss = s[skey];
                    if (typeof ss === "function") {
                        ss.call();
                    }
                }
            }
        }
    }

    window.ScriptsActivator.loadFunctionalityScripts = function () {
        this.loadScripts(window.ScriptsActivator.funcFn);
        this.funcLoaded = true;
    };

    window.ScriptsActivator.loadMarketingScripts = function () {
        this.loadScripts(window.ScriptsActivator.markFn);
        this.markLoaded = true;
    };

    window.ScriptsActivator.loadStatisticsScripts = function () {
        this.loadScripts(window.ScriptsActivator.statFn);
        this.statLoaded = true;
    };

    window.ScriptsActivator.loadAllScripts = function (func, mark, stat) {
        if (func && !this.funcLoaded)
            this.loadFunctionalityScripts();

        if (mark && !this.markLoaded)
            this.loadMarketingScripts();

        if (stat && !this.statLoaded)
            this.loadStatisticsScripts();
    }

    window.ScriptsActivator.removeScriptsElements = function() {
        $("script[data-script]").each(function(a,script) {
            if (script) {
                $(script).remove();
            }
        });
    }

    window.ScriptsActivator.removeScriptsElements();
});
